import config from '../config/config';

class ApiService {
  constructor() {
    this.baseUrl = config.API_BASE_URL;
  }

  getUrl(endpoint) {
    return `${this.baseUrl}${endpoint}`;
  }

  async get(endpoint, options = {}) {
    const token = localStorage.getItem('token');
    const response = await fetch(this.getUrl(endpoint), {
      ...options,
      headers: {
        ...options.headers,
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...(token && { 'x-auth-token': token }),
      },
    });
    return response;
  }

  async post(endpoint, data, options = {}) {
    const token = localStorage.getItem('token');
    const response = await fetch(this.getUrl(endpoint), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...(token && { 'x-auth-token': token }),
        ...options.headers,
      },
      body: JSON.stringify(data),
      ...options,
    });
    return response;
  }
}

export const apiService = new ApiService(); 